import { getApplicationTheme, setApplicationTheme } from '@sas-dvr/ltjs-commons/util/ThemeLoader';
import { useFeatureFlag } from '@sas/nova-commons/hooks/useFeatureFlag';
import { useThemeData } from '@sas/nova-commons/theme';
import { useEffect } from 'react';
const ltjsThemes = ['sas_hcb', 'sas_ignite', 'sas_corporate', 'light', 'dark', 'high-contrast'];
const oldThemeMap = {
  'high-contrast': 'sas_hcb',
  dark: 'sas_ignite',
  light: 'sas_corporate',
  sas_hcb: 'sas_hcb',
  sas_ignite: 'sas_ignite',
  sas_corporate: 'sas_corporate'
};
export function useSyncAppThemeImpl(options) {
  // Sync application theme with the current nova theme
  const themeData = useThemeData();
  const isNewTokenValueFlagEnabled = useFeatureFlag('NOVACOMMONS-22288_ThemeModernization_NewTokenValues');
  useEffect(() => {
    if (options.enabled) {
      setLTJSApplicationThemeImpl({
        themeName: themeData.baseThemeName,
        newTokenValues: isNewTokenValueFlagEnabled
      });
    }
  }, [options.enabled, themeData.baseThemeName, isNewTokenValueFlagEnabled]);
}

/**
 * Updates the global LTJS application theme to match the given Nova base theme name.
 */
export function setLTJSApplicationThemeImpl(options) {
  let ltjsThemeName;
  if (options.newTokenValues) {
    ltjsThemeName = ltjsThemes.includes(options.themeName) ? options.themeName : 'light';
  } else {
    ltjsThemeName = oldThemeMap[options.themeName] ?? 'sas_corporate';
  }
  if (ltjsThemeName !== getApplicationTheme()) {
    setApplicationTheme(ltjsThemeName);
  }
}
//# sourceMappingURL=index.js.map